import React from 'react';

interface IniciativaDetalhesProps {
  titulo: string;
  tema: string;
  descricao: string;
  categoria?: string;
  categoryPremio: string;
  corCategoria: string;
  cadastradoPor: string;
  cadastradoMatricula: string;
  cadastradoData: string;
  inscritoPor: string;
  inscritoMatricula: string;
  inscritoData: string;
}

export const IniciativaDetalhes: React.FC<IniciativaDetalhesProps> = ({
  titulo,
  tema,
  descricao,
  categoria,
  categoryPremio,
  corCategoria,
  cadastradoPor,
  cadastradoMatricula,
  cadastradoData,
  inscritoPor,
  inscritoMatricula,
  inscritoData,
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className={`inline-block self-end px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide tag-${corCategoria}`}>
        {categoria || tema || categoryPremio}
      </div>
      <h2 className="text-[22px] font-bold text-[#1e3a5f] m-0 leading-snug">{titulo}</h2>
      <p className="text-xs text-gray-400 m-0 font-semibold uppercase tracking-wide">{tema}</p>
      <p className="text-sm text-gray-500 m-0 leading-relaxed">{descricao}</p>

      <div className="bg-gray-50 rounded-lg p-3.5 flex flex-col gap-2">
        <div className="flex flex-col gap-0.5">
          <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wide">
            Cadastrado por:
          </span>
          <span className="text-sm text-gray-700">
            {cadastradoPor} ({cadastradoMatricula}){cadastradoData ? `, em ${cadastradoData}` : ''}
          </span>
        </div>
        <div className="flex flex-col gap-0.5">
          <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wide">
            Inscrito por:
          </span>
          <span className="text-sm text-gray-700">
            {inscritoMatricula ? `${inscritoPor} (${inscritoMatricula})` : inscritoPor}{inscritoData ? `, em ${inscritoData}` : ''}
          </span>
        </div>
      </div>
    </div>
  );
};
